import React from 'react';
import { Form } from 'react-bootstrap';
import { IFormItemType } from '@interfaces/FormItemType';
import { CustomInputFeedback } from '@ui/components/atoms';
import InputStyles from './CustomInput.module.scss';

type Props = {
  formItem: IFormItemType;
  isSmallLabel?: boolean;
};

export const CustomInput: React.FC<Props> = ({ formItem, isSmallLabel = false }) => {
  const [numberOfCharacters, setNumberOfCharacters] = React.useState(0);
  return (
    <Form.Group className={InputStyles.form_group} controlId={formItem.id}>
      <Form.Label
        dir="auto"
        className={
          !isSmallLabel ? InputStyles.form_group__label : InputStyles.form_group__label_small
        }
      >
        {formItem.required && <span className={InputStyles.form_group__label_required}>*</span>}{' '}
        {formItem.label} {formItem.isTouched}
      </Form.Label>
      <Form.Control
        className={InputStyles.form_group__input}
        as={formItem.type === 'textarea' ? 'textarea' : undefined}
        rows={3}
        type={formItem.type}
        name={formItem.id}
        placeholder={formItem.type === 'datetime-local' ? undefined : formItem.placeholder}
        value={formItem.value ? String(formItem.value) : ''}
        isInvalid={!formItem.isValid && formItem.isTouched}
        maxLength={formItem.maxLength}
        disabled={formItem.disabled}
        onBlur={formItem.onBlur}
        onChange={(e) => {
          setNumberOfCharacters(e.target.value?.length);
          formItem.onChange(e.target.value);
        }}
      />
      <div
        className="w-100 d-flex justify-content-between align-items-start"
        style={{ gap: '5px' }}
      >
        {formItem.note && (
          <p dir="auto" style={{ color: '#0099A8', fontSize: '12px', margin: 0 }}>
            {formItem.note}
          </p>
        )}
        {formItem.type === 'textarea' && (
          <span style={{ marginInlineStart: 'auto', fontSize: '12px' }}>
            {numberOfCharacters}/{formItem.maxLength}
          </span>
        )}
      </div>
      {formItem.errorFeedback && !formItem.isValid && formItem.isTouched && (
        <CustomInputFeedback errorFeedback={formItem.errorFeedback} />
      )}
    </Form.Group>
  );
};
